import { useState, useEffect } from 'react';
import { Box, Collapse } from '@mui/material';
import StandardErrorAlert from '../../../../components/alerts/StandardErrorAlert';
import CenteredFlexContainer from '../../../../components/containers/CenteredFlexContainer';
import MediumCircularProgress from '../../../../components/progressBar/MediumCircularProgress';
import FullPageCircularProgress from '../../../../components/progressBar/FullPageCircularProgress';
import InfiniteScroll from '../../../../components/common/InfiniteScroll';
import Header from './Header';
import ContentTabs from './ContentTabs';
import SearchFilterBar from './SearchFilterBar';
import ContentDisplay from './ContentDisplay';
import CreatePracticeCollection from '../CreatePracticeCollection';
import { usePracticeCollectionSearch } from '../../hooks/usePracticeCollectionSearch';

const ListPracticeCollection = () => {
  const {
    loading,
    error,
    searchTerm,
    viewType,
    tabValue,
    hasMore,
    submitSearchParams,
    loadMore,
    handleTabChange,
    handleViewTypeChange,
    handleContentGenerated,
    getTabContents,
    refreshTab,
    requestsTab,
    draftTab,
    publishTab,
    approvedTab,
    releasedTab,
    archivedTab,
    showCreateForm,
    setShowCreateForm
  } = usePracticeCollectionSearch();

  const [localSearchTerm, setLocalSearchTerm] = useState('');
  
  useEffect(() => {
    setLocalSearchTerm(searchTerm || '');
  }, [searchTerm]);

  const handleSearchSubmit = (term) => {
    const searchValue = term !== undefined ? term : localSearchTerm;
    submitSearchParams(searchValue);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearchSubmit(localSearchTerm);
    }
  };

  const handleClearSearch = () => {
    submitSearchParams('');
  };

  if (loading && getTabContents()?.length === 0) {
    return (<FullPageCircularProgress />);
  }

  const tabContents = getTabContents() || [];

  const tabConstants = {
    requestsTab,
    draftTab,
    publishTab,
    approvedTab,
    releasedTab,
    archivedTab
  };

  return (
    <Box>
      <Header onCreateNew={() => setShowCreateForm(true)} />
      {error && (<StandardErrorAlert>{error}</StandardErrorAlert>)}
      
      <Collapse in={showCreateForm} mountOnEnter unmountOnExit>
        <Box sx={{ mb: 3 }}>
          <CreatePracticeCollection 
            onCancel={() => setShowCreateForm(false)} 
            onContentGenerated={handleContentGenerated} 
          />
        </Box>
      </Collapse>

      <ContentTabs
        value={tabValue}
        onChange={handleTabChange} />

      <SearchFilterBar
        searchTerm={localSearchTerm}
        viewType={viewType}
        onSearchChange={setLocalSearchTerm}
        onSearchSubmit={handleSearchSubmit}
        onKeyPress={handleKeyPress}
        onViewTypeChange={handleViewTypeChange} />

      <InfiniteScroll
        loading={loading}
        hasMore={hasMore}
        onLoadMore={loadMore}>

        <Box key={tabValue} className="page-transition-enter">
          <ContentDisplay
            contents={tabContents}
            searchTerm={localSearchTerm}
            viewType={viewType}
            tabValue={tabValue}
            onClearSearch={handleClearSearch}
            loading={loading}
            tabConstants={tabConstants}
            onActionComplete={() => refreshTab(tabValue)} />
        </Box>

        {loading && tabContents.length > 0 && (
          <CenteredFlexContainer sx={{ py: 4 }}>
            <MediumCircularProgress />
          </CenteredFlexContainer>
        )}
      </InfiniteScroll>
    </Box>
  );
};

export default ListPracticeCollection;
